"use client";

import Script from "next/script";

type IMobileBigBannerAdProps = {
  adElementId: string;
  asid: number;
};

/**
 * i-mobileビッグバナー広告コンポーネント(728x90)
 * i-mobileの広告スクリプトを読み込み、広告領域をレンダリング
 */
export default function IMobileBigBannerAd({ adElementId, asid }: IMobileBigBannerAdProps) {
  //----------
  // デバッグ用フラグ
  // true にすると広告エリアを黒塗りで表示（配信前の表示確認用）
  //----------
  const DEBUG_SHOW_PLACEHOLDER = false;

  //----------
  // 広告設定
  // @note 公開識別子のため、直接埋め込みで問題なし
  //----------
  const PID = 84498;
  const MID = 590455;

  if (DEBUG_SHOW_PLACEHOLDER) {
    return (
      <div
        style={{
          width: "100%",
          maxWidth: 728,
          height: 90,
          backgroundColor: "#000",
        }}
      />
    );
  }

  return (
    <div id={adElementId}>
      <Script
        async
        src="https://imp-adedge.i-mobile.co.jp/script/v1/spot.js?20220104"
        strategy="afterInteractive"
      />
      <Script
        id={`imobile-big-banner-${asid}`}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(window.adsbyimobile=window.adsbyimobile||[]).push({pid:${PID},mid:${MID},asid:${asid},type:"banner",display:"inline",elementid:"${adElementId}"});`,
        }}
      />
    </div>
  );
}
